import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  useTheme
} from '@mui/material';
import { Add } from '@mui/icons-material';

const MenuDialog = ({
  open,
  onClose,
  recipe,
  menus,
  onAddRecipeToMenu,
  onOpenCreateMenuDialog
}) => {
  const theme = useTheme();
  
  if (!recipe) return null;
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: { width: { xs: '95%', sm: '100%' }, mx: 'auto', borderRadius: { xs: 2, sm: 1 } }
      }}
    >
      <DialogTitle sx={{ py: { xs: 2, sm: 1.5 }, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
        Add to Cocktail Menu
      </DialogTitle>
      <DialogContent dividers>
        <List>
          {menus.map(menu => {
            const isRecipeInMenu = menu.recipes?.includes(recipe.id);
            return (
              <ListItem 
                key={menu.id}
                button
                disabled={isRecipeInMenu}
                onClick={() => {
                  if (!isRecipeInMenu) {
                    onAddRecipeToMenu(menu.id, recipe.id);
                    onClose();
                  }
                }}
                sx={{ py: { xs: 1.5, sm: 1 }, borderBottom: `1px solid ${theme.palette.divider}` }}
              >
                <ListItemText 
                  primary={menu.name}
                  primaryTypographyProps={{ sx: { fontSize: { xs: '1rem', sm: 'inherit' } } }}
                  secondary={isRecipeInMenu ? "Recipe already in menu" : `${menu.recipes?.length || 0} recipes`}
                  secondaryTypographyProps={{ sx: { fontSize: { xs: '0.875rem', sm: '0.75rem' } } }}
                />
              </ListItem>
            );
          })}
          <Divider sx={{ my: 1 }} />
          <ListItem 
            button
            onClick={onOpenCreateMenuDialog}
            sx={{ py: { xs: 1.5, sm: 1 } }}
          >
            <ListItemText 
              primary="Create New Menu"
              primaryTypographyProps={{ sx: { fontSize: { xs: '1rem', sm: 'inherit' } } }}
              secondary="Start a new collection"
              secondaryTypographyProps={{ sx: { fontSize: { xs: '0.875rem', sm: '0.75rem' } } }}
            />
            <Add />
          </ListItem>
        </List>
      </DialogContent>
      <DialogActions sx={{ p: { xs: 2, sm: 1.5 } }}>
        <Button onClick={onClose} sx={{ minWidth: { xs: '80px', sm: '64px' } }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MenuDialog; 